import React from "react";
import { baseLightColors } from "@rentablo/theming";
import i18next from "i18next";
import SpeedMeterIcon from "@icons/myicons/speedmeter.svg?react";
import CoinsIcon from "@icons/myicons/coins-growth-2.svg?react";

const iconSizes = {
  width: 20,
  height: 20,
};

export const getRiskStyle = (classNumber: number) => {
  if (Number.isNaN(classNumber) || classNumber < 0 || classNumber > 6) {
    return {
      color: baseLightColors.N500,
      title: "gaugeChart.riskClass.unknown",
    };
  }

  switch (classNumber) {
    case 0:
      return {
        color: baseLightColors.G900,
        title: "gaugeChart.riskClass.extremelyLow",
      };
    case 1:
      return {
        color: baseLightColors.G500,
        title: "gaugeChart.riskClass.veryLow",
      };
    case 2:
      return {
        color: baseLightColors.G300,
        title: "gaugeChart.riskClass.low",
      };
    case 3:
      return {
        color: baseLightColors.Y500,
        title: "gaugeChart.riskClass.medium",
      };
    case 4:
      return {
        color: baseLightColors.R300,
        title: "gaugeChart.riskClass.high",
      };
    case 5:
      return {
        color: baseLightColors.R500,
        title: "gaugeChart.riskClass.veryHigh",
      };
    case 6:
    default:
      return {
        color: baseLightColors.R700,
        title: "gaugeChart.riskClass.extremelyHigh",
      };
  }
};

export const getPerformanceStyle = (classNumber: number) => {
  if (Number.isNaN(classNumber) || classNumber < 0 || classNumber > 6) {
    return {
      color: baseLightColors.N500,
      title: "gaugeChart.performanceClass.unknown",
    };
  }

  switch (classNumber) {
    case 0:
      return {
        color: baseLightColors.R700,
        title: "gaugeChart.performanceClass.negative",
      };
    case 1:
      return {
        color: baseLightColors.R500,
        title: "gaugeChart.performanceClass.veryLow",
      };
    case 2:
      return {
        color: baseLightColors.R300,
        title: "gaugeChart.performanceClass.low",
      };
    case 3:
      return {
        color: baseLightColors.Y500,
        title: "gaugeChart.performanceClass.medium",
      };
    case 4:
      return {
        color: baseLightColors.G300,
        title: "gaugeChart.performanceClass.high",
      };
    case 5:
      return {
        color: baseLightColors.G500,
        title: "gaugeChart.performanceClass.veryHigh",
      };
    case 6:
    default:
      return {
        color: baseLightColors.G900,
        title: "gaugeChart.performanceClass.top",
      };
  }
};

export const getCenterPanelData = (
  classNumber: number,
  type: "risk" | "performance"
) => {
  const { color, title } =
    type === "risk"
      ? getRiskStyle(classNumber)
      : getPerformanceStyle(classNumber);

  const subtitle =
    type === "risk" ? "gaugeChart.risk" : "gaugeChart.performance";

  return {
    color,
    title: i18next.t(title),
    subtitle: i18next.t(subtitle),
    icon:
      type === "risk" ? (
        <SpeedMeterIcon {...iconSizes} />
      ) : (
        <CoinsIcon {...iconSizes} />
      ),
  };
};
